import { isMobile, isIpad } from 'utils/util';
const Animation = {
  updateHeight(wrapper, content, prevHeight) {
    const shouldGrow = wrapper.offsetHeight < prevHeight;
    wrapper.style.height = prevHeight + 'px';
    let   prev = null;
    const applyChange = function(timestamp) {
      const change = prev ? timestamp - prev : 1,
                 h = parseInt(wrapper.style.height, 10) + (shouldGrow ? -change : change);
              prev = timestamp;
      if((shouldGrow && h > content.offsetHeight) || (!shouldGrow && h < content.offsetHeight)) {
        wrapper.style.height = h + 'px';
        document.getElementById('medscape-tver').style.opacity = document.getElementById('medscape-tver').style.opacity + 0.10;
        requestAnimationFrame(applyChange);
      } else {
        document.getElementById('medscape-tver').style.opacity = 1;
        wrapper.style.height = 'auto';
      }
    };
    requestAnimationFrame(applyChange);
  },
  slideFadeIn(element, elementContent) {
    let start = null;
    element.style.display = 'block';
    elementContent.style.opacity = '0';
    let widthModifier = 2;
    if(isMobile()) {
      widthModifier = 1;
    }
    if(isIpad()) {
      widthModifier = 1.5;
    }
    function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      let width = Math.min(progress/5, 2000);
      width = (width > 100)? 100: width;
      elementContent.style.left =  (100 - width/widthModifier) + '%';
      elementContent.style.opacity = (width / 100);
      if (width < 100) {
        requestAnimationFrame(step);
      }
    }
    requestAnimationFrame(step);
  },
  slideFadeOut(element, elementContent) {
    let start = null;
    element.style.display = 'block';
    element.style.opacity = '1';
    let widthModifier = 2;
    if(isMobile()) {
      widthModifier = 1;
    }
    if(isIpad()) {
      widthModifier = 1.5;
    }
    function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      let width = Math.min(progress/5, 2000);
      width = (width > 100)? 100: width;
      width = 100 - width;
      elementContent.style.left = (100 - (width/2)) + '%';
      elementContent.style.opacity = (width / widthModifier);
      if (width > 0) {
        requestAnimationFrame(step);
      } else {
        element.style.display = 'none';
        elementContent.style.opacity = '0';
      }
    }
    requestAnimationFrame(step);
  }
};
module.exports = Animation;



/** WEBPACK FOOTER **
 ** ./modules/utils/animation.js
 **/